/* eslint-disable consistent-default-export-name/default-export-match-filename */
import Store from './Store'
import reducer, { getInitialState } from './reducer'
// eslint-disable-next-line consistent-default-export-name/default-import-match-filename
import useDispatch from './dispatch'
import { type ConfigUpdate, InitAction, SetConfigAction, SetDataAction } from './actions'
import { ResizeContextProvider } from './ResizeContext'
import { useEffect } from 'react'
import type { TableConfig } from '../../types'
const { Provider } = Store
function UpdateFromChanges<T extends Record<string, unknown>>(props: { data: T[]; config: ConfigUpdate<T> }) {
  const { data, config } = props
  const dispatch = useDispatch<T>()
  useEffect(() => {
    dispatch(new SetDataAction(data))
  }, [data, dispatch])
  useEffect(() => {
    dispatch(new SetConfigAction(config))
  }, [config, dispatch])
  return null
}

function TableStoreProvider<T extends Record<string, unknown>>({
  children,
  data: data,
  config: config,
  tableRef,
}: {
  children: React.ReactNode
  data: T[]
  config: Omit<TableConfig<T>, 'data' | 'scrollToEndLabel'>
  tableRef: React.RefObject<HTMLTableElement | null>
}) {
  return (
    <Provider getInitialState={() => reducer(getInitialState<T>(), new InitAction<T>({ data, config }))}>
      <UpdateFromChanges data={data} config={config} />
      <ResizeContextProvider tableRef={tableRef}>{children}</ResizeContextProvider>
    </Provider>
  )
}

export default TableStoreProvider
